import xhr from 'live/services/xhr'

const BASE_LIVE_REST_URL = '/rest'
const BASE_QUERY_PACKER = '/services/plugin-query-packer'
const BASE_LIVERIG_SERVICES = '/services/plugin-liverig'

// Live rest services
export function fetchDashboards(): Promise<any> {
    return xhr.get(`${BASE_LIVE_REST_URL}/dashboard`)
}
export function getLookupAsset(): Promise<any> {
    return xhr.get(`${BASE_LIVE_REST_URL}/lookup/asset_name_event_type`).then(response => response.data)
}
export function getLookupAssetTypeIdName(): Promise<any> {
    return xhr.get(`${BASE_LIVE_REST_URL}/lookup/asset_type_id_name`).then(response => response.data)
}
export function updateWidget(widget: Record<string, any> | { id: number }): Promise<any> {
    return widget.id && xhr.put(`${BASE_LIVE_REST_URL}/dashboard-widget/${widget.id}`, widget)
}

// Liverig
export function getAssets(): Promise<any> {
    return xhr.get(`${BASE_LIVERIG_SERVICES}/assets/list`).then(response => response.data.filter(d => !!d.name))
}
export function getRigById(id: string): Promise<any> {
    return xhr.get(`${BASE_LIVERIG_SERVICES}/assets/rig/${id}`).then(response => response)
}
export function getRigs(): Promise<any> {
    return xhr.get(`${BASE_LIVERIG_SERVICES}/assets/rig`).then(response => response.data.filter(d => !!d.name))
}
export function getWells(): Promise<any> {
    return xhr.get(`${BASE_LIVERIG_SERVICES}/assets/well`).then(response => response.data.filter(d => !!d.name))
}
export function getRigAttributes(id: string): Promise<any> {
    return xhr.get(`${BASE_LIVERIG_SERVICES}/assets/rig/view/attributes/${id}`).then(response => response.data)
}
export function getWellIntervention(id: string): Promise<any> {
    return xhr.get(`${BASE_LIVERIG_SERVICES}/assets/well/view/intervention/${id}`).then(response => response.data)
}
export function getWellInterventionStatus(): Promise<any> {
    return xhr.get(`${BASE_LIVERIG_SERVICES}/assets/intervention/`).then(response => response.data)
}
export function getWellInterventionDrillingSection(id: string): Promise<any> {
    return xhr
        .get(`${BASE_LIVERIG_SERVICES}/assets/intervention/${id}/part/drilling_sections`)
        .then(response => response.data)
}

// plugin-query-packer
export function getCards(): Promise<any> {
    return xhr.get(`${BASE_QUERY_PACKER}/cards/list`).then(response => response.data)
}
export function getRigInfoById(id: string): Promise<any> {
    return xhr.get(`${BASE_QUERY_PACKER}/navigation/${id}`).then(response => response.data)
}
export function getWellInterventions(): Promise<any> {
    return xhr.get(`${BASE_QUERY_PACKER}/navigation`).then(response => response.data)
}
export function getWellInterventionByRig(id: string): Promise<any> {
    return xhr.get(`${BASE_QUERY_PACKER}/navigation/intervention/${id}`).then(response => response.data)
}
export function getWellInterventionByRigAndWell(rigId: string, wellId: string): Promise<any> {
    return xhr.get(`${BASE_QUERY_PACKER}/navigation/intervention/${rigId}/${wellId}`).then(response => response.data)
}
